import { Pagination, Select, styled } from '@mui/material';

export const sxStyles = {
  selectShowOnPage: {
    display: 'flex',
    alignItems: 'center',
  },
  selectWrap: {
    display: 'flex',
    alignItems: 'center',
  },
  pageInterval: {
    marginLeft: '1rem',
  },
};

export const StyledPaginationWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

export const StyledSelectPerPage = styled(Select)(({ theme }) => ({
  svg: {
    fill: theme.palette.primary.main,
  },

  fieldset: {
    border: 'none',
  },

  '.MuiSelect-select': {
    fontSize: '0.75rem',
  },
}));

export const StyledPagination = styled(Pagination)(({ theme }) => ({
  marginLeft: 0,

  svg: {
    fill: theme.palette.primary.main,
  },

  'button.Mui-selected': {
    // TODO add color to library
    backgroundColor: '#D3D3D3',
  },

  '.MuiPaginationItem-root': {
    fontSize: '0.75rem',
  },

  [theme.breakpoints.up('sm')]: {
    marginLeft: '1.25rem',
  },
}));
